class CustomTabs extends HTMLElement {
  constructor() {
    super();

    this.$container = $(this);
  }

  get selectors() {
    return {
      control: "custom-tabs-control",
      content: "custom-tabs-content"
    }
  }

  get attributes() {
    return {
      index: "index"
    }
  }

  get modifiers() {
    return {
      active: "active"
    }
  }

  connectedCallback() {
    this.initTabs();
  }

  initTabs() {
    const self = this;

    this.$container.on("click", this.selectors.control, function () {
      let $currentControl = $(this);

      if ($currentControl.hasClass(self.modifiers.active)) {
        return false;
      }

      let currentIndex = $currentControl.attr(self.attributes.index);

      let $currentContent = $(`${self.selectors.content}[index=${currentIndex}]`, self.$container);

      $(self.selectors.control, self.$container).removeClass(self.modifiers.active);
      $(self.selectors.content, self.$container).removeClass(self.modifiers.active);

      $currentControl.addClass(self.modifiers.active);
      $currentContent.addClass(self.modifiers.active);
    });

    this.$container.on("keydown", this.selectors.control, function (event) {
      let $currentControl = $(this);

      if (event.key === "Enter" || event.key === " ") {
        $currentControl.trigger("click");
        event.preventDefault();
      }
    });
  }

  switchTabByHandle(handle) {
    const self = this;

    if (!handle) {
      return false;
    }

    let $tabControl = $(`${self.selectors.control}[handle=${handle}]`, self.$container);

    if (!$tabControl) {
      return false;
    }

    $tabControl.trigger("click");
  }
}

if (!customElements.get("custom-tabs")) {
  customElements.define("custom-tabs", CustomTabs);
}
